<template>
  <div class="text-cards-message">
    <div class="warpper">
      <!-- 20191217新增 :mouseDrag="false"-->
      <carousel
        v-if="contentCount > 1 && direction === 'h'"
        :nav="false"
        :mouseDrag="false"
        :dots="false"
        :margin="2"
        :loop="false"
        :auto-width="true"
        :rtl="true"
        class="rich_carousel">

        <!-- 20191217新增 -->
        <template v-if="!isMobile" slot="prev"><span class="prev">prev</span></template>

        <dl v-for="(r, index) of content.cards" :key="index">
          <dd>
            <div class="card_single">
              <div class="content">
                <div class="info">
                  <p v-html="r.text"/>
                </div>
                <div class="rich-btn">
                  <button
                    v-for="(b,index) of r.buttons"
                    :key="index"
                    @click="openTargetUrl(b.payload, b.actionType)">
                  <a v-if="b.actionType == 'text'">{{ b.title }}</a>
                  <a v-if="b.actionType == 'url'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{ b.title }}</a>
                  <a v-if="b.actionType == 'email'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{ b.title }}</a>
                  <a v-if="b.actionType == 'phone'" :href="b.payload" style="color:#000;text-decoration: none">{{ b.title }}</a>
                  </button>
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <!-- 20191217新增 -->
        <template v-if="!isMobile" slot="next"><span class="next">next</span></template>

      </carousel>

      <div v-if="contentCount >1 && direction == 'v' || contentCount == 1" >
        <dl v-for="(r, index) of content.cards" :key="index">
          <br>
          <div class="rich_card float-right">
            <div class="card_single">
              <div class="content">
                <div class="info">
                  <p v-html="r.text"/>
                </div>
                <div class="rich-btn">
                  <button
                    v-for="(b,index) of r.buttons"
                    :key="index"
                    @click="openTargetUrl(b.payload, b.actionType)">
                  <a v-if="b.actionType == 'text'">{{b.title}}</a>
                  <a v-if="b.actionType == 'url'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{b.title}}</a>
                  <a v-if="b.actionType == 'email'" style="color:#000;text-decoration: none" :href="b.payload" target="_blank">{{b.title}}</a>
                  <a v-if="b.actionType == 'phone'" style="color:#000;text-decoration: none" :href="b.payload">{{b.title}}</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "v-owl-carousel";
export default {
  components: {
    carousel
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => {}
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    content() {
      var contentData = {}
      contentData = JSON.parse(this.message.msgJson)
      for (let i = 0; i < contentData.cards.length; i++) {
        // console.log(contentData.cards[i].text)
        // 處理 超連結 和 email
        this.$set(contentData.cards[i], 'text', JSON.parse(this.message.msgJson).cards[i].text)
        // 處理按鈕的 email 
        for (let j = 0; j < contentData.cards[i].buttons.length; j++) {
          if(contentData.cards[i].buttons[j].actionType === 'email'){
            contentData.cards[i].buttons[j].payload = 'mailto:' +
            contentData.cards[i].buttons[j].payload
          } else if (contentData.cards[i].buttons[j].actionType === 'phone') {
            contentData.cards[i].buttons[j].payload = 'tel:' +
            contentData.cards[i].buttons[j].payload
          }
        }
      }
      // console.log(contentData)
      // console.log(contentData.cards[0].text)
      // return JSON.parse(this.message.msgJson);
      return contentData;
    },
    direction(){
      if ('direction' in JSON.parse(this.message.msgJson)) {
        // console.log('有此參數，採用設定:' + JSON.parse(this.message.msgJson).direction)
        return JSON.parse(this.message.msgJson).direction
      } else {
        // console.log('無此參數，預設橫向')
        return 'h'
      }
    },
    contentCount(){
      // console.log(JSON.parse(this.message.msgJson))
      const count = JSON.parse(this.message.msgJson).cards.length
      return count;
    }
  },
  methods: {
    openTargetUrl(payload, actionType) {

      if(actionType == 'text') {
        this.$emit("tag-clicked", payload)
      }

    }
  }
};
</script>

<style scoped>
@import "./styles/textCardsMessage.css";
@import "./styles/rich_carousel.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/TextCardsMessage.vue